import React, { useMemo } from 'react'
import { Stack } from '@mui/material'
import { SelectInput } from '../../../shared/components/SelectInput'
import CommentsViewFilterField from './CommentsViewFilterField'
import CommentsViewFilterAccordionSection from './CommentsViewFilterAccordionSection'
import { CommentsViewAllFilterGroup, CommentsViewDomainFilterId, CommentsViewDomainTabId } from '../CommentsView.types'

type CommentsViewAllFiltersProps = {
    groups: CommentsViewAllFilterGroup[]
    onGroupReset: (domainTabId: CommentsViewDomainTabId) => void
    onSelectionChange: (
        domainTabId: CommentsViewDomainTabId,
        filterId: CommentsViewDomainFilterId,
        selectedOptionIds: string[],
        optionIds: string[]
    ) => void
}

const CommentsViewAllFilters = ({ groups, onGroupReset, onSelectionChange }: CommentsViewAllFiltersProps) => {
    const groupsWithMeta = useMemo(
        () =>
            groups.map((group) => {
                const appliedFiltersCount = group.filters.reduce(
                    (count, filter) => count + (filter.selectedOptionIds.length !== filter.options.length ? 1 : 0),
                    0
                )

                return {
                    ...group,
                    appliedFiltersCount,
                }
            }),
        [groups]
    )

    return (
        <Stack gap={1.5} width="100%">
            {groupsWithMeta.map((group) => {
                return (
                    <CommentsViewFilterAccordionSection
                        key={group.id}
                        title={group.label}
                        appliedCount={group.appliedFiltersCount}
                        defaultExpanded={group.appliedFiltersCount > 0}
                        onClear={() => onGroupReset(group.id)}
                        contentSx={{ width: '100%' }}
                    >
                        {group.filters.map((filter) => {
                            const allOptionIds = filter.options.map((option) => option.id)

                            return (
                                <CommentsViewFilterField
                                    key={filter.id}
                                    label={filter.label}
                                    isActive={filter.selectedOptionIds.length !== filter.options.length}
                                    onClear={() => onSelectionChange(group.id, filter.id, allOptionIds, allOptionIds)}
                                >
                                    <SelectInput
                                        multiple
                                        selected={filter.selectedOptionIds}
                                        onChange={(nextSelectedOptionIds) =>
                                            onSelectionChange(group.id, filter.id, nextSelectedOptionIds, allOptionIds)
                                        }
                                        options={filter.options}
                                        placeholder={filter.placeholder}
                                    />
                                </CommentsViewFilterField>
                            )
                        })}
                    </CommentsViewFilterAccordionSection>
                )
            })}
        </Stack>
    )
}

export default CommentsViewAllFilters
